import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _typeof from "@babel/runtime/helpers/typeof";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ProjectPublishedModal from '../ProjectPublishedModal';
import { analyticsTrack } from '../../analyticsUtils';
import loading from '../../../assets/images/spinner-DNA-2s-200px.svg';
import { deleteRequest, putRequest } from '../../requestUtils';
import { formatCurrency } from '../../numberUtils';
import { decodeAmpersands } from '../../responsibilitiesUtils';
var editPath = function editPath(projectResourceId, step) {
  return "/projects/".concat(projectResourceId, "/edit?from_project_page=true&step=").concat(step);
};
function SectionHeader(_ref) {
  var title = _ref.title,
    step = _ref.step,
    editTitle = _ref.editTitle,
    permissions = _ref.permissions,
    projectResourceId = _ref.projectResourceId;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-summary-card-header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "project-section-title"
  }, title), permissions.update && step ? /*#__PURE__*/React.createElement("a", {
    className: "project-summary-edit-link",
    href: editPath(projectResourceId, step),
    title: editTitle || "Edit ".concat(title)
  }, "Edit", ' ', /*#__PURE__*/React.createElement("i", {
    className: "fa fa-edit"
  })) : '');
}
function InfoRow(_ref2) {
  var icon = _ref2.icon,
    label = _ref2.label,
    value = _ref2.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-summary-info-row"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa ".concat(icon)
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-info-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-info-divider"
  }, "-"), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-info-value"
  }, value || 'N/A'));
}
function BudgetLogisticsSection(_ref3) {
  var project = _ref3.project,
    userType = _ref3.userType,
    ownerOrCloraRep = _ref3.ownerOrCloraRep,
    permissions = _ref3.permissions,
    projectResourceId = _ref3.projectResourceId,
    isCollaborator = _ref3.isCollaborator;
  var max = project.budget_maximum,
    min = project.budget_minimum,
    employmentType = project.employment_type;
  var budget = max && min ? "".concat(formatCurrency(min, 0), " - ").concat(formatCurrency(max, 0)).concat(employmentType === 'full_time' ? ' / year' : ' /hour') : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-overview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-overview-data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row"
  }, userType === 'rep' && project.higher_level_roles.length ? /*#__PURE__*/React.createElement("div", {
    className: "project-role body-text-2 normal-weight muted-gray-text mb-2"
  }, "Relevant Job Role: ".concat(project.higher_level_roles[0])) : '', userType === 'rep' && /*#__PURE__*/React.createElement("div", {
    className: "project-company body-text-2 normal-weight muted-gray-text"
  }, project.job_title && "Relevant Job Titles(s): ".concat(project.job_title), project.job_title && project.company && ' - ')), /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Budget & Logistics",
    step: "logistics",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-info-list"
  }, ownerOrCloraRep && /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-dollar-sign",
    label: employmentType === 'full_time' ? 'Annual Base Salary' : 'Hourly Rate',
    value: budget
  }), !isCollaborator && /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-clock",
    label: "Hours per week",
    value: project.avg_time_required_range ? "".concat(project.avg_time_required_range, " hours") : null
  }), /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-calendar-alt",
    label: "Duration",
    value: project.duration_range ? "".concat(project.duration_range, " ").concat(project.duration_range > 1 ? 'months' : 'month') : null
  }), /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-building",
    label: "Workplace Type",
    value: project.work_location
  }), /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-map-marker-alt",
    label: "Location",
    value: project.office_and_worktype_information
  }), /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-plane",
    label: "Travel Requirements",
    value: project.travel_location_names
  }))));
}
function SenioritySection(_ref4) {
  var project = _ref4.project,
    ownerOrCloraRep = _ref4.ownerOrCloraRep,
    permissions = _ref4.permissions,
    projectResourceId = _ref4.projectResourceId;
  if (!project.seniority.length && !ownerOrCloraRep) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-seniority"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Seniority",
    step: "start",
    editTitle: "Edit Seniority",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), /*#__PURE__*/React.createElement("div", {
    className: "project-summary-info-list"
  }, /*#__PURE__*/React.createElement(InfoRow, {
    icon: "fa-certificate",
    label: "Experience Level",
    value: project.level_names
  })));
}
function AboutProjectSection(_ref5) {
  var project = _ref5.project,
    permissions = _ref5.permissions,
    projectResourceId = _ref5.projectResourceId;
  return /*#__PURE__*/React.createElement("div", {
    className: "project-description"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    title: "About Project",
    step: "description",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), /*#__PURE__*/React.createElement("div", {
    className: "about"
  }, /*#__PURE__*/React.createElement("span", null, project.description)));
}
function SkillRow(_ref6) {
  var id = _ref6.id,
    badgeClass = _ref6.badgeClass,
    skillName = _ref6.skillName,
    skills = _ref6.skills,
    notApplicable = _ref6.notApplicable;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "skill"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-text-3 medium-weight skill-name"
  }, skillName), notApplicable ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "body-text-3 muted-gray-text"
  }, "Not Applicable")) : /*#__PURE__*/React.createElement("div", null, skills.map(function (skill) {
    return /*#__PURE__*/React.createElement("span", {
      key: skill[0],
      className: "badge small ".concat(badgeClass, " ").concat(skill[1] ? 'priority' : '')
    }, skill[0], skill[1] ? /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", null, "*Must have")) : '');
  })));
}
function SkillsRequirementsSection(_ref7) {
  var project = _ref7.project,
    ownerOrCloraRep = _ref7.ownerOrCloraRep,
    permissions = _ref7.permissions,
    projectResourceId = _ref7.projectResourceId;
  return /*#__PURE__*/React.createElement("div", {
    className: "skills"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Skills & Requirements",
    step: "qualifications",
    editTitle: "Edit Qualifications",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), project.area_of_expertises.length || ownerOrCloraRep ? /*#__PURE__*/React.createElement(SkillRow, {
    id: "functional-areas",
    badgeClass: "purple-base",
    skillName: "Functional Areas",
    skills: project.area_of_expertises.map(function (aoe) {
      return [aoe === null || aoe === void 0 ? void 0 : aoe.name, project.priority_expertise_tags.find(function (paoe) {
        return paoe === aoe.name;
      })];
    }),
    notApplicable: false
  }) : '', project.therapeutic_areas.length && !project.therapeutic_areas_not_applicable || ownerOrCloraRep ? /*#__PURE__*/React.createElement(SkillRow, {
    id: "therapeutic-areas",
    badgeClass: "",
    skillName: "Therapeutic Areas",
    skills: project.therapeutic_areas.map(function (ta) {
      return [ta === null || ta === void 0 ? void 0 : ta.name, project.priority_expertise_tags.find(function (pta) {
        return pta === ta.name;
      })];
    }),
    notApplicable: project.therapeutic_areas_not_applicable
  }) : '', project.therapies.length && !project.therapies_not_applicable || ownerOrCloraRep ? /*#__PURE__*/React.createElement(SkillRow, {
    id: "therapies",
    badgeClass: "",
    skillName: "Product Technologies",
    skills: project.therapies.map(function (t) {
      return [t === null || t === void 0 ? void 0 : t.name, project.priority_expertise_tags.find(function (pt) {
        return pt === t.name;
      })];
    }),
    notApplicable: project.therapies_not_applicable
  }) : '', project.disease_codes.length && !project.disease_codes_not_applicable || ownerOrCloraRep ? /*#__PURE__*/React.createElement(SkillRow, {
    id: "disease_codes",
    badgeClass: "",
    skillName: "Diseases/Indications",
    skills: project.disease_codes.map(function (d) {
      return [d === null || d === void 0 ? void 0 : d.name, project.priority_expertise_tags.find(function (pd) {
        return pd === d.name;
      })];
    }),
    notApplicable: project.disease_codes_not_applicable
  }) : '', project.development_phases.length && !project.development_phases_not_applicable || ownerOrCloraRep ? /*#__PURE__*/React.createElement(SkillRow, {
    id: "development_phases",
    badgeClass: "",
    skillName: "Development Phases",
    skills: project.development_phases.map(function (d) {
      return [d === null || d === void 0 ? void 0 : d.name, project.priority_expertise_tags.find(function (pd) {
        return pd === d.name;
      })];
    }),
    notApplicable: project.development_phases_not_applicable
  }) : '', project.regulatory_pathways.length && !project.regulatory_pathways_not_applicable || ownerOrCloraRep ? /*#__PURE__*/React.createElement(SkillRow, {
    id: "regulatory_pathways",
    badgeClass: "",
    skillName: "Regulatory Pathways",
    skills: project.regulatory_pathways.map(function (r) {
      return [r === null || r === void 0 ? void 0 : r.name, project.priority_expertise_tags.find(function (pr) {
        return pr === r.name;
      })];
    }),
    notApplicable: project.regulatory_pathways_not_applicable
  }) : '');
}
function QualificationRow(_ref8) {
  var id = _ref8.id,
    title = _ref8.title,
    items = _ref8.items,
    _ref8$priorityTags = _ref8.priorityTags,
    priorityTags = _ref8$priorityTags === void 0 ? [] : _ref8$priorityTags,
    _ref8$isPriorityCheck = _ref8.isPriorityCheck,
    isPriorityCheck = _ref8$isPriorityCheck === void 0 ? false : _ref8$isPriorityCheck;
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    id: id,
    className: "qualification"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-text-3 medium-weight qualification-name"
  }, title), /*#__PURE__*/React.createElement("ul", {
    className: "normal-weight"
  }, items.map(function (item) {
    var itemName = _typeof(item) === 'object' ? item === null || item === void 0 ? void 0 : item.name : item;
    if (!itemName) return null;
    var isPriority = isPriorityCheck && priorityTags.includes(itemName);
    return /*#__PURE__*/React.createElement("li", {
      key: itemName,
      className: isPriority ? 'priority' : ''
    }, itemName, isPriority && /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", null, "\xA0*Must have")));
  })));
}
function QualificationsSection(_ref9) {
  var project = _ref9.project,
    ownerOrCloraRep = _ref9.ownerOrCloraRep,
    permissions = _ref9.permissions,
    projectResourceId = _ref9.projectResourceId;
  var accreditations = project.accreditations,
    degrees = project.degrees,
    priorityTags = project.priority_expertise_tags,
    languages = project.languages;
  var hasQualifications = degrees.length || accreditations.length || languages.length || ownerOrCloraRep;
  if (!hasQualifications) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "qualifications"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Qualifications",
    step: "qualifications",
    editTitle: "Edit Qualifications",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), degrees.length || ownerOrCloraRep ? /*#__PURE__*/React.createElement(QualificationRow, {
    id: "education-levels",
    title: "Education",
    items: degrees
  }) : null, accreditations.length || ownerOrCloraRep ? /*#__PURE__*/React.createElement(QualificationRow, {
    id: "accreditations",
    title: "Certifications",
    items: accreditations,
    priorityTags: priorityTags,
    isPriorityCheck: true
  }) : null, languages.length || ownerOrCloraRep ? /*#__PURE__*/React.createElement(QualificationRow, {
    id: "languages",
    title: "Languages",
    items: languages
  }) : null);
}
function ResponsibilitiesSection(_ref10) {
  var project = _ref10.project,
    permissions = _ref10.permissions,
    projectResourceId = _ref10.projectResourceId;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "project-responsibilities"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Responsibilities",
    step: "description",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), project.responsibility_areas.length ? /*#__PURE__*/React.createElement("ul", null, project.responsibility_areas.map(function (ra) {
    return /*#__PURE__*/React.createElement("li", {
      key: ra,
      className: "responsibility_area"
    }, decodeAmpersands(ra));
  })) : ''), /*#__PURE__*/React.createElement("div", {
    className: "project-ideal-candidate"
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Ideal Candidate",
    step: "description",
    permissions: permissions,
    projectResourceId: projectResourceId
  }), /*#__PURE__*/React.createElement("ul", null, project.ideal_candidate_list.map(function (ra) {
    return /*#__PURE__*/React.createElement("li", {
      key: ra,
      className: "responsibility_area"
    }, decodeAmpersands(ra));
  }))));
}
function AdminInfoSection(_ref11) {
  var project = _ref11.project,
    showAdminInfo = _ref11.showAdminInfo,
    onToggle = _ref11.onToggle,
    permissions = _ref11.permissions,
    projectResourceId = _ref11.projectResourceId;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3 mb-4 admin"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "project-section-title mb-2"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn-view-admin-info",
    onClick: onToggle,
    role: "button",
    tabIndex: 0
  }, showAdminInfo ? 'Hide' : 'Show', ' ', "Admin Info")), showAdminInfo && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "mb-12"
  }, permissions.update ? /*#__PURE__*/React.createElement("a", {
    href: editPath(projectResourceId, 'admin'),
    className: "required"
  }, "Update") : 'Update'), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    key: "take-rate",
    id: "take-rate"
  }, "Clora take rate:", ' ', project.clora_take_rate * 100, "%"), /*#__PURE__*/React.createElement("li", {
    key: "consultant-take-rate",
    id: "consultant-take-rate"
  }, "Consultant take home:", project.consultant_take_home_minimum ? "$".concat(parseInt(project.consultant_take_home_minimum, 0), " - ") : ' ?', project.consultant_take_home_maximum ? "$".concat(parseInt(project.consultant_take_home_maximum, 0)) : '', "/hour"), project.have_internal_budget_approval ? /*#__PURE__*/React.createElement("li", {
    key: "status",
    className: "status"
  }, /*#__PURE__*/React.createElement("span", {
    id: "status"
  }, "The project has internal budget approval")) : '', project.consultant_working_with ? /*#__PURE__*/React.createElement("li", {
    key: "consultant-working-with",
    className: "consultant-working-with"
  }, "Working with:", ' ', project.consultant_working_with) : '', project.tax_type ? /*#__PURE__*/React.createElement("li", {
    key: "key_type",
    id: "tax_type"
  }, "Tax filing:", ' ', project.tax_type === 'n/a' ? 'TBD' : project.tax_type_collection) : '', project.consultant_needs_sign_agreement ? /*#__PURE__*/React.createElement("li", {
    key: "non_compete",
    id: "non_compete"
  }, "Need to sign a non compete agreement.") : ''), project.approximate_start_date_local ? /*#__PURE__*/React.createElement("div", {
    className: "commitment approximate-start-date-local"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-hourglass-start",
    style: {
      marginRight: '10px'
    }
  }), "Starting", ' ', project.start_date_display) : ''));
}
var ProjectSummary = /*#__PURE__*/function (_Component) {
  function ProjectSummary(props) {
    var _this;
    _classCallCheck(this, ProjectSummary);
    _this = _callSuper(this, ProjectSummary, [props]);
    _this.state = {
      showAdminInfo: false
    };
    _this.handleDeleteProject = _this.handleDeleteProject.bind(_this);
    _this.handlePublishProject = _this.handlePublishProject.bind(_this);
    _this.handleUnpublishProject = _this.handleUnpublishProject.bind(_this);
    _this.handleDuplicateProject = _this.handleDuplicateProject.bind(_this);
    _this.handleStepNavigation = _this.handleStepNavigation.bind(_this);
    _this.toggleShowAdminInfo = _this.toggleShowAdminInfo.bind(_this);
    return _this;
  }
  _inherits(ProjectSummary, _Component);
  return _createClass(ProjectSummary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      analyticsTrack('Viewed project details tab', {
        location: 'Projects view'
      });
    }
  }, {
    key: "toggleShowAdminInfo",
    value: function toggleShowAdminInfo(event) {
      event.preventDefault();
      this.setState(function (prevState) {
        return {
          showAdminInfo: !prevState.showAdminInfo
        };
      });
    }
  }, {
    key: "handleDeleteProject",
    value: function handleDeleteProject() {
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        csrfToken = _this$props.csrfToken;
      if (!window.confirm('Are you sure you want to delete this project?')) return;
      deleteRequest("/projects/".concat(projectResourceId), csrfToken);
    }
  }, {
    key: "handlePublishProject",
    value: function handlePublishProject() {
      var _this$props2 = this.props,
        projectResourceId = _this$props2.projectResourceId,
        csrfToken = _this$props2.csrfToken;
      if (!window.confirm('Are you sure you want to publish this project?')) return;
      putRequest("/projects/".concat(projectResourceId, "/publish"), {}, csrfToken);
    }
  }, {
    key: "handleStepNavigation",
    value: function handleStepNavigation(title) {
      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';
      var _this$props3 = this.props,
        projectResourceId = _this$props3.projectResourceId,
        permissions = _this$props3.permissions;
      return /*#__PURE__*/React.createElement(Fragment, null, permissions.update && /*#__PURE__*/React.createElement("a", {
        className: "edit-logistics-button",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: title,
        href: "/projects/".concat(projectResourceId, "/edit?from_project_page=true&step=").concat(step)
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      })));
    }
  }, {
    key: "handleUnpublishProject",
    value: function handleUnpublishProject() {
      var _this$props4 = this.props,
        projectResourceId = _this$props4.projectResourceId,
        csrfToken = _this$props4.csrfToken;
      if (!window.confirm('Are you sure you want to retract this project?')) return;
      putRequest("/projects/".concat(projectResourceId, "/unpublish"), {}, csrfToken);
    }
  }, {
    key: "handleDuplicateProject",
    value: function handleDuplicateProject() {
      var _this$props5 = this.props,
        projectResourceId = _this$props5.projectResourceId,
        csrfToken = _this$props5.csrfToken;
      putRequest("/projects/".concat(projectResourceId, "/duplicate"), {}, csrfToken).then(function (response) {
        window.location = response.data.url;
      });
    }
  }, {
    key: "renderEditLink",
    value: function renderEditLink(label, section, id) {
      var permission = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'update';
      var className = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'required';
      var title = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var _this$props6 = this.props,
        permissions = _this$props6.permissions,
        projectResourceId = _this$props6.projectResourceId;
      var data = title ? {
        placement: 'bottom',
        toggle: 'tooltip'
      } : {};
      if (!permissions[permission]) {
        return /*#__PURE__*/React.createElement("h2", {
          className: "project-section-title"
        }, label);
      }
      var url = "/projects/".concat(projectResourceId, "/edit?from_project_page=true");
      if (section) {
        url = [url, "step=".concat(section)].join('&');
      }
      return /*#__PURE__*/React.createElement("a", {
        href: url,
        id: id,
        className: className,
        title: title,
        data: data
      }, label);
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var _this$props7 = this.props,
        permissions = _this$props7.permissions,
        project = _this$props7.project;
      var errors = project.error_messages;
      var showRequestMatching = project.status === 'employer_draft' && project.error_messages.length < 1 && permissions.publish;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-error-container white-container box-shadow-1  mb-3  "
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-9"
      }, /*#__PURE__*/React.createElement("div", {
        id: "error_explanation",
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "demibold pb-8"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), "Complete required field".concat(errors.length > 1 ? 's' : '', " to be able to submit your project to Clora for review.")), /*#__PURE__*/React.createElement("ul", null, errors.map(function (error) {
        return /*#__PURE__*/React.createElement("li", {
          key: error,
          className: "body-text-2 pb-4"
        }, error);
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "masthead__actions-right style-guide d-flex flex-column gap-2"
      }, this.renderEditLink('Edit Project', null, 'edit-project', 'update', "btn standard-button\n                ".concat(project.status === 'employer_draft' ? 'btn-primary' : 'btn-default')), permissions.destroy ? /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        id: "delete-project",
        onClick: this.handleDeleteProject,
        className: "btn standard-button full-width\n                    ".concat(project.editable ? 'btn-primary' : 'btn-default', "\n                    ").concat(permissions.update ? '' : 'disabled')
      }, "\uD83D\uDDD1 Delete") : '', showRequestMatching ? /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        id: "publish-project",
        onClick: this.handlePublishProject,
        className: "btn publish-project btn-primary"
      }, "Request Matching") : '', project.status !== 'employer_requested_matching' && permissions.unpublish ? /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        id: "unpublish-project",
        onClick: this.handleUnpublishProject,
        className: "btn btn-default unpublish-project\n                      ".concat(project.editable ? 'btn-primary' : 'btn-default disabled')
      }, "Retract Submission") : ''))));
    }
  }, {
    key: "renderHoursPerWeek",
    value: function renderHoursPerWeek() {
      var _this$props8 = this.props,
        project = _this$props8.project,
        ownerOrCloraRep = _this$props8.ownerOrCloraRep;
      return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep || project.avg_time_required_range ? /*#__PURE__*/React.createElement("div", {
        className: "commitment hours-per-week"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-clock"
      }), project.avg_time_required_range ? project.avg_time_required_text || "".concat(project.avg_time_required_range, " hours per week") : '') : this.renderEditLink('Average Time', 'start', null, 'update'));
    }
  }, {
    key: "renderBudget",
    value: function renderBudget() {
      var _this$props9 = this.props,
        project = _this$props9.project,
        ownerOrCloraRep = _this$props9.ownerOrCloraRep;
      var max = project.budget_maximum,
        min = project.budget_minimum,
        employmentType = project.employment_type;
      var budgetText = employmentType === 'full_time' ? 'Annual base salary range: ' : 'Hourly rate: ';
      var budget = max && min ? "".concat(formatCurrency(min, 0), " - ").concat(formatCurrency(max, 0)) : null;
      return /*#__PURE__*/React.createElement(Fragment, null, ownerOrCloraRep ? /*#__PURE__*/React.createElement("div", {
        className: "commitment hourly-rate"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-dollar-sign"
      }), budget ? "".concat(budgetText, " ").concat(budget) : this.renderEditLink(employmentType === 'full_time' ? 'Base Salary' : 'Hourly Rate', 'logistics', null, 'update')) : '');
    }
  }, {
    key: "renderTravelRequirement",
    value: function renderTravelRequirement() {
      var _this$props10 = this.props,
        project = _this$props10.project,
        showProjectEmploymentType = _this$props10.showProjectEmploymentType;
      return /*#__PURE__*/React.createElement("div", {
        className: "commitment travel"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plane"
      }), showProjectEmploymentType ? "Travel Requirements: ".concat(project.travel_location_names ? project.travel_location_names : 'N/A') : "Travel Requirements - ".concat(project.travel_location_names ? project.travel_location_names : 'N/A'));
    }
  }, {
    key: "renderLocationAndWorktype",
    value: function renderLocationAndWorktype() {
      var project = this.props.project;
      return /*#__PURE__*/React.createElement(Fragment, null, project.work_location && /*#__PURE__*/React.createElement("div", {
        className: "commitment work-location"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-map-marker-alt"
      }), "".concat(project.office_and_worktype_information)));
    }
  }, {
    key: "renderSeniority",
    value: function renderSeniority() {
      var _this$props11 = this.props,
        project = _this$props11.project,
        ownerOrCloraRep = _this$props11.ownerOrCloraRep,
        permissions = _this$props11.permissions,
        projectResourceId = _this$props11.projectResourceId;
      return /*#__PURE__*/React.createElement(Fragment, null, project.seniority.length || ownerOrCloraRep ? /*#__PURE__*/React.createElement("div", {
        className: "commitment seniority"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-certificate"
      }), /*#__PURE__*/React.createElement("div", {
        className: "levels"
      }, project.seniority.length ? project.level_names : this.renderEditLink('Experience Levels', 'start', null, 'update')), permissions.update ? /*#__PURE__*/React.createElement("a", {
        className: "edit-budget-button",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Edit Seniority/Budget",
        href: "/projects/".concat(projectResourceId, "/edit?step=start&from_project_page=true")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      })) : '') : '');
    }
  }, {
    key: "renderDuration",
    value: function renderDuration() {
      var _this$props12 = this.props,
        project = _this$props12.project,
        ownerOrCloraRep = _this$props12.ownerOrCloraRep,
        permissions = _this$props12.permissions,
        projectResourceId = _this$props12.projectResourceId;
      return /*#__PURE__*/React.createElement(Fragment, null, project.duration_range || ownerOrCloraRep ? /*#__PURE__*/React.createElement("div", {
        className: "commitment duration"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-calendar-day"
      }), project.duration_range ? project.duration_text || "".concat(project.duration_range, " ").concat(project.duration_range > 1 ? ' months' : ' month') : this.renderEditLink('Duration Range', 'start', null, 'update'), permissions.update ? /*#__PURE__*/React.createElement("a", {
        className: "edit-logistics-button",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Edit Logistics",
        href: "/projects/".concat(projectResourceId, "/edit?step=start&from_project_page=true")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      })) : '') : '');
    }
  }, {
    key: "renderOverview",
    value: function renderOverview() {
      var _this$props13 = this.props,
        project = _this$props13.project,
        userType = _this$props13.userType,
        ownerOrCloraRep = _this$props13.ownerOrCloraRep,
        permissions = _this$props13.permissions,
        projectResourceId = _this$props13.projectResourceId,
        isCollaborator = _this$props13.isCollaborator;
      var max = project.budget_maximum,
        min = project.budget_minimum,
        employmentType = project.employment_type;
      var budget = max && min ? "".concat(formatCurrency(min, 0), " - ").concat(formatCurrency(max, 0)).concat(employmentType === 'full_time' ? ' / year' : ' /hour') : null;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-overview"
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-overview-data"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, userType === 'rep' && project.higher_level_roles.length ? /*#__PURE__*/React.createElement("div", {
        className: "project-role body-text-2 normal-weight muted-gray-text mb-2"
      }, "Relevant Job Role: ".concat(project.higher_level_roles[0])) : '', userType === 'rep' && /*#__PURE__*/React.createElement("div", {
        className: "project-company body-text-2 normal-weight muted-gray-text"
      }, project.job_title && "Relevant Job Titles(s): ".concat(project.job_title), project.job_title && project.company && ' - ')), this.renderCardHeader('Budget & Logistics', 'logistics'), /*#__PURE__*/React.createElement("div", {
        className: "project-summary-info-list"
      }, ownerOrCloraRep && this.renderInfoRow('fa-dollar-sign', employmentType === 'full_time' ? 'Annual Base Salary' : 'Hourly Rate', budget), !isCollaborator && this.renderInfoRow('fa-clock', 'Hours per week', project.avg_time_required_range ? "".concat(project.avg_time_required_range, " hours") : null), this.renderInfoRow('fa-calendar-alt', 'Duration', project.duration_range ? "".concat(project.duration_range, " ").concat(project.duration_range > 1 ? 'months' : 'month') : null), this.renderInfoRow('fa-building', 'Workplace Type', project.work_location), this.renderInfoRow('fa-map-marker-alt', 'Location', project.office_and_worktype_information), this.renderInfoRow('fa-plane', 'Travel Requirements', project.travel_location_names))), permissions.edit || permissions.duplicate ? /*#__PURE__*/React.createElement("div", {
        className: "project-overview-buttons"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, permissions.edit ? /*#__PURE__*/React.createElement("a", {
        className: "edit-project-button",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Edit Project",
        href: "/projects/".concat(projectResourceId, "/edit?from_project_page=true")
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      })) : '', permissions.duplicate ? /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        className: "duplicate-project-button",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Duplicate Project",
        onClick: this.handleDuplicateProject
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-clone"
      })) : '')) : '');
    }
  }, {
    key: "renderAboutSection",
    value: function renderAboutSection() {
      var project = this.props.project;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-description"
      }, this.renderCardHeader('About Project', 'description'), /*#__PURE__*/React.createElement("div", {
        className: "about"
      }, /*#__PURE__*/React.createElement("span", null, project.description)));
    }
  }, {
    key: "renderResponsibilities",
    value: function renderResponsibilities() {
      var project = this.props.project;
      return [/*#__PURE__*/React.createElement("div", {
        key: "responsibilities",
        className: "project-responsibilities"
      }, this.renderCardHeader('Responsibilities', 'description'), project.responsibility_areas.length ? /*#__PURE__*/React.createElement("ul", null, project.responsibility_areas.map(function (ra) {
        return /*#__PURE__*/React.createElement("li", {
          key: ra,
          className: "responsibility_area"
        }, decodeAmpersands(ra));
      })) : ''), /*#__PURE__*/React.createElement("div", {
        key: "ideal-candidate",
        className: "project-ideal-candidate"
      }, this.renderCardHeader('Ideal Candidate', 'description'), /*#__PURE__*/React.createElement("ul", null, project.ideal_candidate_list.map(function (ra) {
        return /*#__PURE__*/React.createElement("li", {
          key: ra,
          className: "responsibility_area"
        }, decodeAmpersands(ra));
      })))];
    }
  }, {
    key: "renderAdminSection",
    value: function renderAdminSection() {
      var project = this.props.project;
      var showAdminInfo = this.state.showAdminInfo;
      return /*#__PURE__*/React.createElement("div", {
        className: "mt-3 mb-4 admin"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "project-section-title mb-2"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn-view-admin-info",
        onClick: this.toggleShowAdminInfo,
        role: "button",
        tabIndex: 0
      }, showAdminInfo ? 'Hide' : 'Show', ' ', "Admin Info")), showAdminInfo && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
        className: "mb-12"
      }, this.renderEditLink('Update', 'admin', null, 'update')), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
        key: "take-rate",
        id: "take-rate"
      }, "Clora take rate:", ' ', project.clora_take_rate * 100, "%"), /*#__PURE__*/React.createElement("li", {
        key: "consultant-take-rate",
        id: "consultant-take-rate"
      }, "Consultant take home:", project.consultant_take_home_minimum ? "$".concat(parseInt(project.consultant_take_home_minimum, 0), " - ") : ' ?', project.consultant_take_home_maximum ? "$".concat(parseInt(project.consultant_take_home_maximum, 0)) : '', "/hour"), project.have_internal_budget_approval ? /*#__PURE__*/React.createElement("li", {
        key: "status",
        className: "status"
      }, /*#__PURE__*/React.createElement("span", {
        id: "status"
      }, "The project has internal budget approval")) : '', project.consultant_working_with ? /*#__PURE__*/React.createElement("li", {
        key: "consultant-working-with",
        className: "consultant-working-with"
      }, "Working with:", ' ', project.consultant_working_with) : '', project.tax_type ? /*#__PURE__*/React.createElement("li", {
        key: "key_type",
        id: "tax_type"
      }, "Tax filing:", ' ', project.tax_type === 'n/a' ? 'TBD' : project.tax_type_collection) : '', project.consultant_needs_sign_agreement ? /*#__PURE__*/React.createElement("li", {
        key: "non_compete",
        id: "non_compete"
      }, "Need to sign a non compete agreement.") : ''), project.approximate_start_date_local ? /*#__PURE__*/React.createElement("div", {
        className: "commitment approximate-start-date-local"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-hourglass-start",
        style: {
          marginRight: '10px'
        }
      }), "Starting", ' ', project.start_date_display) : ''));
    }
  }, {
    key: "renderSkill",
    value: function renderSkill(id, badgeClass, skillName, skills, notApplicable) {
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: "skill"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-3 medium-weight skill-name"
      }, skillName), notApplicable ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "body-text-3 muted-gray-text"
      }, "Not Applicable")) : /*#__PURE__*/React.createElement("div", null, skills.map(function (skill) {
        return /*#__PURE__*/React.createElement("span", {
          className: "badge small ".concat(badgeClass, " ").concat(skill[1] ? 'priority' : '')
        }, skill[0], skill[1] ? /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", null, "*Must have")) : '');
      })));
    }
  }, {
    key: "renderSkills",
    value: function renderSkills() {
      var _this$props14 = this.props,
        project = _this$props14.project,
        ownerOrCloraRep = _this$props14.ownerOrCloraRep;
      return /*#__PURE__*/React.createElement("div", {
        className: "skills"
      }, this.renderCardHeader('Skills & Requirements', 'qualifications', 'Edit Qualifications'), project.area_of_expertises.length || ownerOrCloraRep ? this.renderSkill('functional-areas', 'purple-base', 'Functional Areas', project.area_of_expertises.map(function (aoe) {
        return [aoe === null || aoe === void 0 ? void 0 : aoe.name, project.priority_expertise_tags.find(function (paoe) {
          return paoe === aoe.name;
        })];
      }), false) : '', project.therapeutic_areas.length && !project.therapeutic_areas_not_applicable || ownerOrCloraRep ? this.renderSkill('therapeutic-areas', '', 'Therapeutic Areas', project.therapeutic_areas.map(function (ta) {
        return [ta === null || ta === void 0 ? void 0 : ta.name, project.priority_expertise_tags.find(function (pta) {
          return pta === ta.name;
        })];
      }), project.therapeutic_areas_not_applicable) : '', project.therapies.length && !project.therapies_not_applicable || ownerOrCloraRep ? this.renderSkill('therapies', '', 'Product Technologies', project.therapies.map(function (t) {
        return [t === null || t === void 0 ? void 0 : t.name, project.priority_expertise_tags.find(function (pt) {
          return pt === t.name;
        })];
      }), project.therapies_not_applicable) : '', project.disease_codes.length && !project.disease_codes_not_applicable || ownerOrCloraRep ? this.renderSkill('disease_codes', '', 'Diseases/Indications', project.disease_codes.map(function (d) {
        return [d === null || d === void 0 ? void 0 : d.name, project.priority_expertise_tags.find(function (pd) {
          return pd === d.name;
        })];
      }), project.disease_codes_not_applicable) : '', project.development_phases.length && !project.development_phases_not_applicable || ownerOrCloraRep ? this.renderSkill('development_phases', '', 'Development Phases', project.development_phases.map(function (d) {
        return [d === null || d === void 0 ? void 0 : d.name, project.priority_expertise_tags.find(function (pd) {
          return pd === d.name;
        })];
      }), project.development_phases_not_applicable) : '', project.regulatory_pathways.length && !project.regulatory_pathways_not_applicable || ownerOrCloraRep ? this.renderSkill('regulatory_pathways', '', 'Regulatory Pathways', project.regulatory_pathways.map(function (r) {
        return [r === null || r === void 0 ? void 0 : r.name, project.priority_expertise_tags.find(function (pr) {
          return pr === r.name;
        })];
      }), project.regulatory_pathways_not_applicable) : '');
    }
  }, {
    key: "renderQualifications",
    value: function renderQualifications() {
      var _this$props15 = this.props,
        ownerOrCloraRep = _this$props15.ownerOrCloraRep,
        _this$props15$project = _this$props15.project,
        accreditations = _this$props15$project.accreditations,
        degrees = _this$props15$project.degrees,
        priority_expertise_tags = _this$props15$project.priority_expertise_tags,
        languages = _this$props15$project.languages;
      var hasQualifications = degrees.length || accreditations.length || languages.length || ownerOrCloraRep;
      var renderQualificationSection = function renderQualificationSection(id, title, items) {
        var isPriorityCheck = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return /*#__PURE__*/React.createElement("div", {
          key: id,
          id: id,
          className: "qualification"
        }, /*#__PURE__*/React.createElement("div", {
          className: "body-text-3 medium-weight qualification-name"
        }, title), /*#__PURE__*/React.createElement("ul", {
          className: "normal-weight"
        }, items.map(function (item) {
          var itemName = _typeof(item) === 'object' ? item === null || item === void 0 ? void 0 : item.name : item;
          if (!itemName) return null;
          var isPriority = isPriorityCheck && priority_expertise_tags.includes(itemName);
          return /*#__PURE__*/React.createElement("li", {
            key: itemName,
            className: isPriority ? 'priority' : ''
          }, itemName, isPriority && /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", null, "\xA0*Must have")));
        })));
      };
      return hasQualifications && /*#__PURE__*/React.createElement("div", {
        className: "qualifications"
      }, this.renderCardHeader('Qualifications', 'qualifications', 'Edit Qualifications'), degrees.length || ownerOrCloraRep ? renderQualificationSection('education-levels', 'Education', degrees) : null, accreditations.length || ownerOrCloraRep ? renderQualificationSection('accreditations', 'Certifications', accreditations, true) : null, languages.length || ownerOrCloraRep ? renderQualificationSection('languages', 'Languages', languages) : null);
    }
  }, {
    key: "renderProjectDisplay",
    value: function renderProjectDisplay() {
      var _this$props16 = this.props,
        project = _this$props16.project,
        showPublishedModal = _this$props16.showPublishedModal,
        userType = _this$props16.userType,
        ownerOrCloraRep = _this$props16.ownerOrCloraRep,
        permissions = _this$props16.permissions,
        projectResourceId = _this$props16.projectResourceId,
        isCollaborator = _this$props16.isCollaborator;
      var showAdminInfo = this.state.showAdminInfo;
      return /*#__PURE__*/React.createElement(Fragment, null, showPublishedModal ? /*#__PURE__*/React.createElement(ProjectPublishedModal, {
        referralUrl: "/referrals"
      }) : '', /*#__PURE__*/React.createElement("section", {
        className: "project-view project project-summary-redesign ".concat(project.status === 'clora_matching' || project.open_marketplace ? 'open-opportunity' : 'upcoming-opportunity', " ").concat(project.open_marketplace ? 'open-marketplace' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-details-header"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "project-details-title"
      }, "Project Details"), /*#__PURE__*/React.createElement("div", {
        className: "budget-action-buttons"
      }, permissions.edit ? /*#__PURE__*/React.createElement("a", {
        className: "edit-project-button project-summary-edit-link",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Edit Project",
        href: "/projects/".concat(projectResourceId, "/edit?from_project_page=true")
      }, "Review", ' ', /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      })) : '', permissions.duplicate ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "duplicate-project-button project-summary-edit-link",
        "data-toggle": "tooltip",
        "data-placement": "bottom",
        title: "Duplicate Project",
        onClick: this.handleDuplicateProject
      }, "Clone", ' ', /*#__PURE__*/React.createElement("i", {
        className: "fa fa-clone"
      })) : '')), /*#__PURE__*/React.createElement(SenioritySection, {
        project: project,
        ownerOrCloraRep: ownerOrCloraRep,
        permissions: permissions,
        projectResourceId: projectResourceId
      }), /*#__PURE__*/React.createElement(BudgetLogisticsSection, {
        project: project,
        userType: userType,
        ownerOrCloraRep: ownerOrCloraRep,
        permissions: permissions,
        projectResourceId: projectResourceId,
        isCollaborator: isCollaborator
      }), /*#__PURE__*/React.createElement("div", {
        className: "project-summary-card-stack body-text-2"
      }, /*#__PURE__*/React.createElement(AboutProjectSection, {
        project: project,
        permissions: permissions,
        projectResourceId: projectResourceId
      }), /*#__PURE__*/React.createElement(SkillsRequirementsSection, {
        project: project,
        ownerOrCloraRep: ownerOrCloraRep,
        permissions: permissions,
        projectResourceId: projectResourceId
      }), /*#__PURE__*/React.createElement(QualificationsSection, {
        project: project,
        ownerOrCloraRep: ownerOrCloraRep,
        permissions: permissions,
        projectResourceId: projectResourceId
      }), /*#__PURE__*/React.createElement(ResponsibilitiesSection, {
        project: project,
        permissions: permissions,
        projectResourceId: projectResourceId
      }), userType === 'rep' ? /*#__PURE__*/React.createElement(AdminInfoSection, {
        project: project,
        showAdminInfo: showAdminInfo,
        onToggle: this.toggleShowAdminInfo,
        permissions: permissions,
        projectResourceId: projectResourceId
      }) : ''), userType === 'rep' ? /*#__PURE__*/React.createElement("div", {
        className: "updated-at-container mt-60 body-text-3 mb-3"
      }, project.owner ? /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, project.owner_display) : /*#__PURE__*/React.createElement("div", null, "Created:", project.created_at)) : ''));
    }
  }, {
    key: "renderStartProject",
    value: function renderStartProject() {
      var project = this.props.project;
      return /*#__PURE__*/React.createElement("div", {
        className: "no-padding-white-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "start-your-own-project"
      }, project.feedbacks.length && !(project.status === 'employer_draft' || project.status === 'employer_requested_matching') ? /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "Leaving feedback is no longer available and no feedbacks are available to be displayed") : /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, /*#__PURE__*/React.createElement("span", {
        className: "fs-hide body-text-1 demibold"
      }, project.owner || project.owner_email), ' ', "is using Clora to find expert life sciences consultants for this project."), /*#__PURE__*/React.createElement("a", {
        href: "/projects/add_project",
        className: "btn btn-primary"
      }, "Start Your Own Project")));
    }
  }, {
    key: "render",
    value: function render() {
      var project = this.props.project;
      if (!project) {
        return /*#__PURE__*/React.createElement("div", {
          className: "loading"
        }, /*#__PURE__*/React.createElement("img", {
          src: loading,
          alt: "Loading_image"
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "g-flex-8 project-info-column"
      }, project.error_messages.length ? this.renderErrors() : '', /*#__PURE__*/React.createElement("div", {
        className: "project-info-box project-summary-shell"
      }, this.renderProjectDisplay()));
    }
  }]);
}(Component);
ProjectSummary.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  project: PropTypes.shape({}),
  projectResourceId: PropTypes.string.isRequired,
  permissions: PropTypes.shape({}),
  ownerOrCloraRep: PropTypes.bool,
  showPublishedModal: PropTypes.bool,
  userType: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool
};
ProjectSummary.defaultProps = {
  project: null,
  permissions: {},
  ownerOrCloraRep: false,
  showPublishedModal: false,
  showProjectEmploymentType: false
};
export default ProjectSummary;